import { render } from "./NewIframe.vue?vue&type=template&id=1e5808b0"
import script from "./NewIframe.vue?vue&type=script&lang=js"
export * from "./NewIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__